import { Card, Tabs, Typography } from "antd";

import "./Settings.scss";
import { ProfileSettingsForm } from "users/components";
import { LoginAndSecuritySettingsForm } from "auth/components";

export const Settings = () => {
  return (
    <Card className="settings-container">
      <Typography.Title level={1}>Settings</Typography.Title>
      <Tabs
        defaultActiveKey='1'
        items={[
          {
            label: "Profile",
            key: "1",
            children: <ProfileSettingsForm />,
          },
          {
            label: "Login & Security",
            key: "2",
            children: <LoginAndSecuritySettingsForm />,
          },
          {
            label: "Notifications",
            key: "3",
            children: "Notifications",
            disabled: true,
          },
        ]}
      />
    </Card>
  );
};
